import { createContext, useEffect, useRef, useState } from "react";
import { getPartRequestSupplyChainList } from "../Services/PartRequestManagementService";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";

const PartRequestManagementContext = createContext();

const PartRequestManagemenProvider = ({ children }) => {
  const pageSize = 10;
  const [filters, setFilters] = useState({ dropdowns: {}, txt: {} });
  const [dataList, setDataList] = useState([]);
  const [loadingParts, setLoadingParts] = useState(false);
  const [page, setPage] = useState(0);
  const [maxPages, setMaxPages] = useState(null);
  const [partsToOrder, setPartsToOrder] = useState([]);
  const [search, setSearch] = useState("");
  const didMount = useRef(false);
  const [sortingOrder, setSortingOrder] = useState("date_request_required");
  const [updateInfoList, setUpdateInfoList] = useState(null)
  const onFiltersChange = (dropdownFilters, txtFilters) => {
    setFilters({
      dropdowns: dropdownFilters,
      txt: txtFilters,
    });
  };
  const addType = () => {};

  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };
    useEffect(() => {
          window.addEventListener("keydown", handleEnterKey);
      return () => {
        window.removeEventListener("keydown", handleEnterKey);
      };
    }, []);
      const handleEnterKey = (event) => {
      if (event.ctrlKey && event.key === "l") {
        setUpdateInfoList(new Date().getTime());
      }
    };
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    setLoadingParts(true);
    getPartRequestSupplyChainList(page, pageSize, search, sortingOrder)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => ({
            ...item,
            date_request_required: item.date_request_required.split("T")[0],
            status: !item.available_quantity
              ? "error"
              : item.available_quantity >= item.remaining_quantity
              ? "success"
              : "warning",
          }));

          setDataList((prev) =>
            page > 0 ? [...prev, ...inventoryArray] : [...inventoryArray]
          );
          setLoadingParts(false);
        }
      })
      .catch((error) => setLoadingParts(false));
  }, [page, search]);

    useEffect(() => {
      
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    setPage(0);
    setLoadingParts(true);
    getPartRequestSupplyChainList(0, pageSize, search, sortingOrder)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => ({
            ...item,
            date_request_required: item.date_request_required.split("T")[0],
            status: !item.available_quantity
              ? "error"
              : item.available_quantity >= item.remaining_quantity
              ? "success"
              : "warning",
          }));

          setDataList(inventoryArray);
          setLoadingParts(false);
        }
      })
      .catch((error) => setLoadingParts(false));
  }, [sortingOrder, updateInfoList])

  const onSearch = (value) => {
    setSearch(value);
  };
  return (
    <PartRequestManagementContext.Provider
      value={{
        onFiltersChange,
        addType,
        onSearch,
        partsToOrder,
        setPartsToOrder,
        dataList,
        setDataList,
        loadingParts,
        setLoadingParts,
        setSortingOrder,
        requestNextPage,
        setUpdateInfoList,
        updateInfoList,
        page
      }}
    >
      {children}
    </PartRequestManagementContext.Provider>
  );
};
export { PartRequestManagementContext, PartRequestManagemenProvider };
